import * as buttons from 'smg/buttons';
import { AddCartItems } from 'smg/customer-api/carts';
import { GetStockItemPrice } from 'smg/customer-api/stockitems';
import { HandleRequestError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import { Relref } from '../hugo';
import * as stockitems from '../stockitems';

export default function main() {
    stockitems.InitGallery();
    stockitems.InitSeeMore();
    void stockitems.InitPrices(true, true);

    const $form = document.querySelector('#stock-item-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    const $numberOfSides = document.querySelector('#number-of-sides') as HTMLSelectElement;
    const $size = document.querySelector('#size') as HTMLSelectElement;
    const $orderReference = document.querySelector('#order-reference') as HTMLInputElement;

    const $quantity = document.querySelector('#quantity') as HTMLInputElement;
    const $addToCart = document.querySelector('#add-to-cart') as HTMLButtonElement;

    const $priceStartsAt = document.querySelectorAll<HTMLElement>('.price-starts-at');

    const ids = {
        'S6': 'Ee6S1YZSmA6_AwJCrBIABA',
        'S10': 'Ee6S2GEikzOf4Q4wCW7zqg',
        'S12': 'Ee6S2GEnoR-f4Q4wCW7zqg',
        'D6': 'Ee6S2GEstxif4Q4wCW7zqg',
        'D10': 'Ee6S2GEx1sWf4Q4wCW7zqg',
        'D12': 'Ee6S2GE2-C-f4Q4wCW7zqg',
    };

    const updatePriceStartsAt = async () => {
        let price = Number(await GetStockItemPrice(ids.S6, 1));
        switch ($numberOfSides.value) {
        case 'Double Sided':
            switch ($size.value) {
            case '6"':
                price = Number(await GetStockItemPrice(ids.D6, 1));
                break;
            case '10"':
                price = Number(await GetStockItemPrice(ids.D10, 1));
                break;
            case '12"':
                price = Number(await GetStockItemPrice(ids.D12, 1));
                break;
            default:
                price = Number(await GetStockItemPrice(ids.D6, 1));
                break;
            }
            break;
        case 'Single Sided':
            switch ($size.value) {
            case '6"':
                price = Number(await GetStockItemPrice(ids.S6, 1));
                break;
            case '10"':
                price = Number(await GetStockItemPrice(ids.S10, 1));
                break;
            case '12"':
                price = Number(await GetStockItemPrice(ids.S12, 1));
                break;
            default:
                price = Number(await GetStockItemPrice(ids.S6, 1));
                break;
            }
            break;
        }

        $priceStartsAt.forEach($el => {
            $el.innerText = `$${price}`;
        });
    };

    $numberOfSides.addEventListener('change', updatePriceStartsAt);
    $size.addEventListener('change', updatePriceStartsAt);

    $form.noValidate = true;
    $form.addEventListener('submit', e => {
        e.preventDefault();

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.disabled = true;
        buttons.Start($addToCart);

        let stockItemID = '';
        switch ($numberOfSides.value) {
        case 'Double Sided':
            switch ($size.value) {
            case '6"':
                stockItemID = 'Ee6S2GEstxif4Q4wCW7zqg';
                break;
            case '10"':
                stockItemID = 'Ee6S2GEx1sWf4Q4wCW7zqg';
                break;
            case '12"':
                stockItemID = 'Ee6S2GE2-C-f4Q4wCW7zqg';
                break;
            }
            break;
        case 'Single Sided':
            switch ($size.value) {
            case '6"':
                stockItemID = 'Ee6S1YZSmA6_AwJCrBIABA';
                break;
            case '10"':
                stockItemID = 'Ee6S2GEikzOf4Q4wCW7zqg';
                break;
            case '12"':
                stockItemID = 'Ee6S2GEnoR-f4Q4wCW7zqg';
                break;
            }
            break;
        }

        AddCartItems({
            stockItemID,
            quantity: parseInt($quantity.value, 10),
            customizations: {
                'Order or Quote #': $orderReference.value,
            },
        }).then(() => {
            window.location.href = Relref('/cart');
        }).catch(err => {
            $fieldset.disabled = false;
            buttons.Stop($addToCart);
            HandleRequestError(err);
        });
    });
}